/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../app/app.module';
import * as i2 from '../../app/app.component';
import * as i3 from '../../$$_gendir/node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-backdrop.ngfactory';
import * as i4 from '../../$$_gendir/node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-window.ngfactory';
import * as i5 from '../../$$_gendir/node_modules/ngx-toastr/index.ngfactory';
import * as i6 from '../../$$_gendir/node_modules/ng-block-ui/dist/lib/components/block-ui/block-ui.component.ngfactory';
import * as i7 from '../../$$_gendir/node_modules/ng-block-ui/dist/lib/components/block-ui-content/block-ui-content.component.ngfactory';
import * as i8 from './clmtlk/login/login.component.ngfactory';
import * as i9 from './clmtlk/inbox/inbox.component.ngfactory';
import * as i10 from './clmtlk/thread/thread.component.ngfactory';
import * as i11 from './clmtlk/new-message/new-message.component.ngfactory';
import * as i12 from './common/component/401-unauthorize.component.ngfactory';
import * as i13 from './app.component.ngfactory';
import * as i14 from '@angular/common';
import * as i15 from '@angular/platform-browser';
import * as i16 from '@angular/animations/browser';
import * as i17 from '@angular/platform-browser/animations';
import * as i18 from '@angular/animations';
import * as i19 from '@angular/http';
import * as i20 from '@angular/forms';
import * as i21 from '@ng-bootstrap/ng-bootstrap/modal/modal-stack';
import * as i22 from '@ng-bootstrap/ng-bootstrap/modal/modal';
import * as i23 from 'ngx-webstorage/dist/services/sessionStorage';
import * as i24 from 'ngx-webstorage/dist/services/localStorage';
import * as i25 from 'ng-block-ui/dist/lib/services/block-ui-instance.service';
import * as i26 from 'ng-block-ui/dist/lib/block-ui.module';
import * as i27 from 'ng-block-ui/dist/lib/services/block-ui.service';
import * as i28 from '../../app/clmtlk/core/shared/core.service';
import * as i29 from '@angular/router';
import * as i30 from 'ngx-toastr';
import * as i31 from '../../app/clmtlk/shared/service/clmtlk-session.service';
import * as i32 from '../../app/common/service/exception.service';
import * as i33 from '../../app/common/service/window-ref.service';
import * as i34 from '../../app/clmtlk/shared/service/clmtlk.service';
import * as i35 from '../../app/common/service/model-helper.service';
import * as i36 from '../../app/common/service/google-analytics.service';
import * as i37 from '../../app/clmtlk/shared/service/clmtlk-candeactivate.service';
import * as i38 from '../../app/clmtlk/inbox/shared/inbox.service';
import * as i39 from '../../app/clmtlk/inbox/shared/inbox-resolver.service';
import * as i40 from '../../app/clmtlk/new-message/shared/new-message.service';
import * as i41 from '../../app/clmtlk/new-message/shared/new-message-resolver.service';
import * as i42 from '../../app/clmtlk/thread/thread.service';
import * as i43 from '../../app/clmtlk/new-message/shared/autocomplete-resolver.service';
import * as i44 from 'primeng/components/common/confirmationservice';
import * as i45 from 'primeng/components/common/shared';
import * as i46 from 'primeng/components/dropdown/dropdown';
import * as i47 from 'primeng/components/paginator/paginator';
import * as i48 from 'primeng/components/datatable/datatable';
import * as i49 from 'primeng/components/button/button';
import * as i50 from 'primeng/components/confirmdialog/confirmdialog';
import * as i51 from 'primeng/components/inputtext/inputtext';
import * as i52 from 'primeng/components/autocomplete/autocomplete';
import * as i53 from 'primeng/components/radiobutton/radiobutton';
import * as i54 from 'primeng/components/inputmask/inputmask';
import * as i55 from 'primeng/components/progressbar/progressbar';
import * as i56 from 'primeng/components/messages/messages';
import * as i57 from 'primeng/components/fileupload/fileupload';
import * as i58 from '../../app/clmtlk/login/login.component';
import * as i59 from '../../app/clmtlk/inbox/inbox.component';
import * as i60 from '../../app/clmtlk/thread/thread.component';
import * as i61 from '../../app/clmtlk/new-message/new-message.component';
import * as i62 from '../../app/common/component/401-unauthorize.component';
import * as i63 from 'primeng/components/menu/menu';
import * as i64 from 'ngx-ui-switch/src/index';
import * as i65 from 'primeng/components/checkbox/checkbox';
import * as i66 from '@ng-bootstrap/ng-bootstrap/modal/modal.module';
import * as i67 from 'ngx-webstorage/dist/app';
import * as i68 from 'ngx-webstorage/dist/interfaces/config';
import * as i69 from '../../app/clmtlk/core/core.module';
import * as i70 from '../../app/common/sticky/ng2-sticky-kit';
import * as i71 from 'primeng/components/accordion/accordion';
import * as i72 from '../../app/clmtlk/shared/shared.module';
import * as i73 from 'primeng/components/selectbutton/selectbutton';
import * as i74 from '../../app/app-routing.module';
export const AppModuleNgFactory:i0.NgModuleFactory<i1.AppModule> = i0.ɵcmf(i1.AppModule,
    [i2.AppComponent],(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i3.NgbModalBackdropNgFactory,i4.NgbModalWindowNgFactory,i5.ToastNgFactory,
              i6.BlockUIComponentNgFactory,i7.BlockUIContentComponentNgFactory,i8.LoginComponentNgFactory,
              i9.InboxComponentNgFactory,i10.ThreadComponentNgFactory,i11.NewMessageComponentNgFactory,
              i12.UnauthorizeComponentNgFactory,i13.AppComponentNgFactory]],[3,i0.ComponentFactoryResolver],
              i0.NgModuleRef]),i0.ɵmpd(5120,i0.LOCALE_ID,i0.ɵm,[[3,i0.LOCALE_ID]]),
          i0.ɵmpd(4608,i14.NgLocalization,i14.NgLocaleLocalization,[i0.LOCALE_ID]),
          i0.ɵmpd(5120,i0.APP_ID,i0.ɵf,([] as any[])),i0.ɵmpd(5120,i0.IterableDiffers,
              i0.ɵk,([] as any[])),i0.ɵmpd(5120,i0.KeyValueDiffers,i0.ɵl,([] as any[])),
          i0.ɵmpd(4608,i15.DomSanitizer,i15.ɵe,[i14.DOCUMENT]),i0.ɵmpd(6144,i0.Sanitizer,
              (null as any),[i15.DomSanitizer]),i0.ɵmpd(4608,i15.HAMMER_GESTURE_CONFIG,
              i15.HammerGestureConfig,([] as any[])),i0.ɵmpd(5120,i15.EVENT_MANAGER_PLUGINS,
              (p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
                return [new i15.ɵDomEventsPlugin(p0_0),new i15.ɵKeyEventsPlugin(p1_0),
                    new i15.ɵHammerGesturesPlugin(p2_0,p2_1)];
              },[i14.DOCUMENT,i14.DOCUMENT,i14.DOCUMENT,i15.HAMMER_GESTURE_CONFIG]),
          i0.ɵmpd(4608,i15.EventManager,i15.EventManager,[i15.EVENT_MANAGER_PLUGINS,
              i0.NgZone]),i0.ɵmpd(135680,i15.ɵDomSharedStylesHost,i15.ɵDomSharedStylesHost,
              [i14.DOCUMENT]),i0.ɵmpd(4608,i15.ɵDomRendererFactory2,i15.ɵDomRendererFactory2,
              [i15.EventManager,i15.ɵDomSharedStylesHost]),i0.ɵmpd(4608,i16.AnimationDriver,
              i16.ɵNoopAnimationDriver,([] as any[])),i0.ɵmpd(5120,i16.ɵAnimationStyleNormalizer,
              i17.ɵd,([] as any[])),i0.ɵmpd(4608,i16.ɵAnimationEngine,i17.ɵb,[i16.AnimationDriver,
              i16.ɵAnimationStyleNormalizer]),i0.ɵmpd(5120,i0.RendererFactory2,i17.ɵe,
              [i15.ɵDomRendererFactory2,i16.ɵAnimationEngine,i0.NgZone]),i0.ɵmpd(6144,
              i15.ɵSharedStylesHost,(null as any),[i15.ɵDomSharedStylesHost]),i0.ɵmpd(4608,
              i0.Testability,i0.Testability,[i0.NgZone]),i0.ɵmpd(4608,i15.Meta,i15.Meta,
              [i14.DOCUMENT]),i0.ɵmpd(4608,i15.Title,i15.Title,[i14.DOCUMENT]),i0.ɵmpd(4608,
              i18.AnimationBuilder,i17.ɵBrowserAnimationBuilder,[i0.RendererFactory2,
                  i15.DOCUMENT]),i0.ɵmpd(4608,i19.BrowserXhr,i19.BrowserXhr,([] as any[])),
          i0.ɵmpd(4608,i19.ResponseOptions,i19.BaseResponseOptions,([] as any[])),
          i0.ɵmpd(5120,i19.XSRFStrategy,i19.ɵb,([] as any[])),i0.ɵmpd(4608,i19.XHRBackend,
              i19.XHRBackend,[i19.BrowserXhr,i19.ResponseOptions,i19.XSRFStrategy]),
          i0.ɵmpd(4608,i19.RequestOptions,i19.BaseRequestOptions,([] as any[])),i0.ɵmpd(5120,
              i19.Http,i19.ɵc,[i19.XHRBackend,i19.RequestOptions]),i0.ɵmpd(4608,i20.ɵi,
              i20.ɵi,([] as any[])),i0.ɵmpd(4608,i21.NgbModalStack,i21.NgbModalStack,
              [i0.ApplicationRef,i0.Injector,i0.ComponentFactoryResolver]),i0.ɵmpd(4608,
              i22.NgbModal,i22.NgbModal,[i0.ComponentFactoryResolver,i0.Injector,i21.NgbModalStack]),
          i0.ɵmpd(4608,i23.SessionStorageService,i23.SessionStorageService,([] as any[])),
          i0.ɵmpd(4608,i24.LocalStorageService,i24.LocalStorageService,([] as any[])),
          i0.ɵmpd(5120,i25.BlockUIInstanceService,i26.provideInstance,([] as any[])),
          i0.ɵmpd(4608,i27.BlockUIService,i27.BlockUIService,[i25.BlockUIInstanceService]),
          i0.ɵmpd(4608,i28.CoreService,i28.CoreService,[i19.Http]),i0.ɵmpd(5120,i29.ActivatedRoute,
              i29.ɵf,[i29.Router]),i0.ɵmpd(4608,i29.NoPreloading,i29.NoPreloading,
              ([] as any[])),i0.ɵmpd(6144,i29.PreloadingStrategy,(null as any),[i29.NoPreloading]),
          i0.ɵmpd(135680,i29.RouterPreloader,i29.RouterPreloader,[i29.Router,i0.NgModuleFactoryLoader,
              i0.Compiler,i0.Injector,i29.PreloadingStrategy]),i0.ɵmpd(4608,i29.PreloadAllModules,
              i29.PreloadAllModules,([] as any[])),i0.ɵmpd(5120,i29.ROUTER_INITIALIZER,
              i29.ɵi,[i29.ɵg]),i0.ɵmpd(5120,i0.APP_BOOTSTRAP_LISTENER,(p0_0:any) => {
            return [p0_0];
          },[i29.ROUTER_INITIALIZER]),i0.ɵmpd(4608,i30.OverlayContainer,i30.OverlayContainer,
              ([] as any[])),i0.ɵmpd(4608,i30.Overlay,i30.Overlay,[i30.OverlayContainer,
              i0.ComponentFactoryResolver,i0.ApplicationRef]),i0.ɵmpd(4608,i30.ToastrService,
              i30.ToastrService,[i30.TOAST_CONFIG,i30.Overlay,i0.Injector,i15.DomSanitizer]),
          i0.ɵmpd(4608,i31.ClmtlkSessionService,i31.ClmtlkSessionService,[i23.SessionStorageService]),
          i0.ɵmpd(4608,i32.ExceptionService,i32.ExceptionService,[i29.Router]),i0.ɵmpd(4608,
              i33.WindowRefService,i33.WindowRefService,([] as any[])),i0.ɵmpd(4608,
              i34.ClmtlkService,i34.ClmtlkService,[i19.Http,i31.ClmtlkSessionService,
                  i32.ExceptionService,i33.WindowRefService]),i0.ɵmpd(4608,i35.HelperService,
              i35.HelperService,([] as any[])),i0.ɵmpd(4608,i36.GoogleAnalyticsService,
              i36.GoogleAnalyticsService,([] as any[])),i0.ɵmpd(4608,i14.DatePipe,
              i14.DatePipe,[i0.LOCALE_ID]),i0.ɵmpd(4608,i37.ClmtlkCanDeactivate,i37.ClmtlkCanDeactivate,
              ([] as any[])),i0.ɵmpd(4608,i38.InboxService,i38.InboxService,[i19.Http]),
          i0.ɵmpd(4608,i39.InboxResolver,i39.InboxResolver,[i34.ClmtlkService,i29.Router,
              i27.BlockUIService,i31.ClmtlkSessionService,i30.ToastrService]),i0.ɵmpd(4608,
              i40.NewMessageService,i40.NewMessageService,[i19.Http]),i0.ɵmpd(4608,
              i41.NewMessageResolver,i41.NewMessageResolver,[i34.ClmtlkService,i29.Router,
                  i27.BlockUIService,i31.ClmtlkSessionService,i35.HelperService]),
          i0.ɵmpd(4608,i42.ThreadService,i42.ThreadService,[i19.Http]),i0.ɵmpd(4608,
              i43.AutoCompleteResolver,i43.AutoCompleteResolver,[i34.ClmtlkService,
                  i29.Router,i27.BlockUIService,i31.ClmtlkSessionService,i35.HelperService]),
          i0.ɵmpd(4608,i44.ConfirmationService,i44.ConfirmationService,([] as any[])),
          i0.ɵmpd(512,i14.CommonModule,i14.CommonModule,([] as any[])),i0.ɵmpd(1024,
              i0.ErrorHandler,i15.ɵa,([] as any[])),i0.ɵmpd(1024,i0.NgProbeToken,() => {
            return [i29.ɵb()];
          },([] as any[])),i0.ɵmpd(512,i29.ɵg,i29.ɵg,[i0.Injector]),i0.ɵmpd(1024,i0.APP_INITIALIZER,
              (p0_0:any,p0_1:any,p1_0:any) => {
                return [i15.ɵc(p0_0,p0_1),i29.ɵh(p1_0)];
              },[[2,i15.NgProbeToken],[2,i0.NgProbeToken],i29.ɵg]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,[i0.ApplicationRef]),
          i0.ɵmpd(512,i15.BrowserModule,i15.BrowserModule,[[3,i15.BrowserModule]]),
          i0.ɵmpd(512,i17.NoopAnimationsModule,i17.NoopAnimationsModule,([] as any[])),
          i0.ɵmpd(512,i19.HttpModule,i19.HttpModule,([] as any[])),i0.ɵmpd(512,i20.ɵba,
              i20.ɵba,([] as any[])),i0.ɵmpd(512,i20.FormsModule,i20.FormsModule,([] as any[])),
          i0.ɵmpd(512,i45.SharedModule,i45.SharedModule,([] as any[])),i0.ɵmpd(512,
              i46.DropdownModule,i46.DropdownModule,([] as any[])),i0.ɵmpd(512,i47.PaginatorModule,
              i47.PaginatorModule,([] as any[])),i0.ɵmpd(512,i48.DataTableModule,i48.DataTableModule,
              ([] as any[])),i0.ɵmpd(512,i49.ButtonModule,i49.ButtonModule,([] as any[])),
          i0.ɵmpd(512,i50.ConfirmDialogModule,i50.ConfirmDialogModule,([] as any[])),
          i0.ɵmpd(512,i51.InputTextModule,i51.InputTextModule,([] as any[])),i0.ɵmpd(512,
              i52.AutoCompleteModule,i52.AutoCompleteModule,([] as any[])),i0.ɵmpd(512,
              i53.RadioButtonModule,i53.RadioButtonModule,([] as any[])),i0.ɵmpd(512,
              i54.InputMaskModule,i54.InputMaskModule,([] as any[])),i0.ɵmpd(512,i55.ProgressBarModule,
              i55.ProgressBarModule,([] as any[])),i0.ɵmpd(512,i56.MessagesModule,
              i56.MessagesModule,([] as any[])),i0.ɵmpd(512,i57.FileUploadModule,i57.FileUploadModule,
              ([] as any[])),i0.ɵmpd(1024,i29.ɵa,i29.ɵd,[[3,i29.Router]]),i0.ɵmpd(512,
              i29.UrlSerializer,i29.DefaultUrlSerializer,([] as any[])),i0.ɵmpd(512,
              i29.ChildrenOutletContexts,i29.ChildrenOutletContexts,([] as any[])),
          i0.ɵmpd(256,i29.ROUTER_CONFIGURATION,{useHash:true},([] as any[])),i0.ɵmpd(1024,
              i14.LocationStrategy,i29.ɵc,[i14.PlatformLocation,[2,i14.APP_BASE_HREF],
                  i29.ROUTER_CONFIGURATION]),i0.ɵmpd(512,i14.Location,i14.Location,
              [i14.LocationStrategy]),i0.ɵmpd(512,i0.Compiler,i0.Compiler,([] as any[])),
          i0.ɵmpd(512,i0.NgModuleFactoryLoader,i0.SystemJsNgModuleLoader,[i0.Compiler,
              [2,i0.SystemJsNgModuleLoaderConfig]]),i0.ɵmpd(1024,i29.ROUTES,() => {
            return [[{path:'',redirectTo:'/inbox',pathMatch:'full'},{path:'login',
                component:i58.LoginComponent},{path:'inbox',component:i59.InboxComponent,
                resolve:{convContacts:i39.InboxResolver}},{path:'convo/:conv_id/:thread/:thrd_id',
                component:i60.ThreadComponent},{path:'message/:action',component:i61.NewMessageComponent,
                resolve:{conversation:i41.NewMessageResolver,streamContacts:i43.AutoCompleteResolver},
                canDeactivate:[i37.ClmtlkCanDeactivate]},{path:'401',component:i62.UnauthorizeComponent},
                {path:'**',redirectTo:'/inbox'}]];
          },([] as any[])),i0.ɵmpd(1024,i29.Router,i29.ɵe,[i0.ApplicationRef,i29.UrlSerializer,
              i29.ChildrenOutletContexts,i14.Location,i0.Injector,i0.NgModuleFactoryLoader,
              i0.Compiler,i29.ROUTES,i29.ROUTER_CONFIGURATION,[2,i29.UrlHandlingStrategy],
              [2,i29.RouteReuseStrategy]]),i0.ɵmpd(512,i29.RouterModule,i29.RouterModule,
              [[2,i29.ɵa],[2,i29.Router]]),i0.ɵmpd(512,i63.MenuModule,i63.MenuModule,
              ([] as any[])),i0.ɵmpd(512,i64.UiSwitchModule,i64.UiSwitchModule,([] as any[])),
          i0.ɵmpd(512,i65.CheckboxModule,i65.CheckboxModule,([] as any[])),i0.ɵmpd(512,
              i66.NgbModalModule,i66.NgbModalModule,([] as any[])),i0.ɵmpd(512,i30.ToastrModule,
              i30.ToastrModule,[[3,i30.ToastrModule]]),i0.ɵmpd(256,i67.WEBSTORAGE_CONFIG,
              {prefix:'clmtlk',separator:'|',caseSensitive:true},([] as any[])),i0.ɵmpd(1024,
              i68.WebstorageConfig,i67.provideConfig,[i67.WEBSTORAGE_CONFIG]),i0.ɵmpd(512,
              i67.Ng2Webstorage,i67.Ng2Webstorage,[i0.NgZone,[2,i68.WebstorageConfig]]),
          i0.ɵmpd(512,i26.BlockUIModule,i26.BlockUIModule,([] as any[])),i0.ɵmpd(512,
              i69.CoreModule,i69.CoreModule,([] as any[])),i0.ɵmpd(512,i70.StickyModule,
              i70.StickyModule,([] as any[])),i0.ɵmpd(512,i71.AccordionModule,i71.AccordionModule,
              ([] as any[])),i0.ɵmpd(512,i72.SharedModule,i72.SharedModule,([] as any[])),
          i0.ɵmpd(512,i73.SelectButtonModule,i73.SelectButtonModule,([] as any[])),
          i0.ɵmpd(512,i74.AppRoutingModule,i74.AppRoutingModule,([] as any[])),i0.ɵmpd(512,
              i1.AppModule,i1.AppModule,([] as any[])),i0.ɵmpd(256,i30.TOAST_CONFIG,
              {maxOpened:1,preventDuplicates:true},([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9qZW5raW5zX2hvbWUvd29ya3NwYWNlL0NMQUlNU19QSVBFTElORS9DTE1UTEtfVUlfQVBQX1BJUEVMSU5FL3NyYy9hcHAvYXBwLm1vZHVsZS5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvamVua2luc19ob21lL3dvcmtzcGFjZS9DTEFJTVNfUElQRUxJTkUvQ0xNVExLX1VJX0FQUF9QSVBFTElORS9zcmMvYXBwL2FwcC5tb2R1bGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/$$_gendir/app/app.module.ngfactory.ts